import React from 'react';
import FleetWidget from 'models/fleet-management/FleetWidget';
import CustomAlert from '@common/components/Feedback/CustomAlert';
import { useTranslation } from 'react-i18next';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import ResponsiveTypography from 'components/misc/ResponsiveTypography';
import { formatWidgetValue, getDataValueByFieldAndOperation } from 'utils/fleet-filters';

const CardWidget: React.FC<{ widget: FleetWidget; data: any[] | null }> = ({ widget, data }) => {
  const { t } = useTranslation();

  if (widget.fields == null || widget.fields.length !== 1) {
    return <CustomAlert header={t('error-card-incorrectly-configured')} severity="error" />;
  }

  const value = getDataValueByFieldAndOperation(widget.fields[0], data);

  return (
    <Stack flex={1} overflow="hidden" justifyContent="space-around" width="100%">
      {value != null && (
        <ResponsiveTypography
          text={formatWidgetValue(value)}
          variant="h1"
          maxFontSize={80}
          minFontSize={4}
        />
      )}
      <FormHelperText sx={{ textAlign: 'center' }}>
        {t('fleet-management-field-' + widget.fields[0].name)}
      </FormHelperText>
    </Stack>
  );
};

export default CardWidget;
